export default "__VITE_ASSET__0gXcPV3X__"